"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Title_1 = tslib_1.__importDefault(require("./Title"));
var H3 = function (_a) {
    var children = _a.children, style = _a.style;
    return (react_1.default.createElement(Title_1.default, { level: 3, style: style }, children));
};
exports.default = H3;
//# sourceMappingURL=H3.js.map